import {isNotEmpty} from "./CommonUtil.ts";
import Noty from "noty";
import "noty/lib/noty.css";
import "noty/lib/themes/semanticui.css";
import "../../style/common/noty/message_noty.scss";

const _theme = "semanticui";

/**
 * 確認ダイアログ表示
 */
export function popConfirm(
    message: string,
    callAccept = () => {},
    callDecline = () => {}) {
    confirmMessage({
        message: message,
        callAccept: callAccept,
        callDecline: callDecline,
    });
}

/**
 * メッセージ表示
 */
export function popInfo(message: string, callClose = () => {}) {
    showMessages({
        message: message, type: "info",
        callClose: callClose,
    })
}

/**
 * エラー表示
 */
export function popErrors(message: string, callClose = () => {}) {
    showMessages({message: message, type: "error", callClose: callClose})
}


/**
 * メッセージ表示（改行をリスト表示）
 */
function showMessages(
    {
        message = "",
        layout = "center",
        modal = true,
        type = "info",
        callClose = () => {}
    }) {
    let error_message = "";
    if(/\r\n|\r|\n/.test(message)) {
        error_message =
            "<ul>";
        const textArray = message.split(/\r\n|\r|\n/);
        textArray.forEach(function(value: string) {
            if (isNotEmpty(value)) {
                error_message = error_message + "<li>" + value + "</li>";
            }
        });
        error_message = error_message + "</ul>";
    } else {
        error_message = message;
    }
    let n = new Noty({
        text: error_message,
        theme: _theme,
        modal: modal,
        // @ts-ignore
        type: type,
        // @ts-ignore
        layout: layout,
        closeWith: [],
        buttons: [
            Noty.button(
                "閉じる",
                "btn btn-light btn-sm",
                function () {
                    callClose();
                    n.close();
                },
                { id: "button1", "data-status": "ok" }
            ),
        ],
    });
    n.show();
}


/**
 * 確認ダイアログ表示
 */
function confirmMessage(
    {
        message = "",
        layout = "center",
        modal = true,
        type = "alert",
        callAccept = () => {},
        callDecline = () => {},
    }) {
    let n = new Noty({
        text: message,
        theme: _theme,
        modal: modal,
        // @ts-ignore
        type: type,
        // @ts-ignore
        layout: layout,
        className: "confirm-message-noty",
        closeWith: [],
        buttons: [
            Noty.button(
                "いいえ",
                "btn btn-secondary btn-sm",
                function () {
                    callDecline();
                    n.close();
                },
                { id: "btn-no", "data-status": "no" }
            ),
            Noty.button(
                "はい",
                "btn btn-primary btn-sm",
                function () {
                    callAccept();
                    n.close();
                },
                { id: "btn-yes", "data-status": "yes" }
            ),
        ],
    });
    n.show();
}
